var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyGpsHorizontalWhiteText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3758.79 961.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-15,.cls-16,.cls-5{fill:none;}.cls-6{fill:url(#linear-gradient-5);}.cls-7{fill:url(#linear-gradient-6);}.cls-8{fill:url(#linear-gradient-7);}.cls-9{fill:url(#linear-gradient-8);}.cls-10{fill:url(#linear-gradient-9);}.cls-11{fill:url(#linear-gradient-10);}.cls-12{fill:url(#linear-gradient-11);}.cls-13{fill:url(#linear-gradient-12);}.cls-14{fill:#fff;}.cls-15,.cls-16{stroke:#fff;stroke-miterlimit:10;}.cls-16{strokeWidth:4px;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -3507.1,
    y1: 510.14,
    x2: -3515.17,
    y2: 499.28,
    gradientTransform: "matrix(80.59, 0, 0, -79.98, 283469.79, 40816.49)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c60a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9313ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -3508.91,
    y1: 503.18,
    x2: -3511.62,
    y2: 501.09,
    gradientTransform: "matrix(73.17, 0, 0, -70.63, 257036.34, 36169.14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5200b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133ca6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -3508.38,
    y1: 469.9,
    x2: -3516.93,
    y2: 460.44,
    gradientTransform: "matrix(65.66, 0, 0, -79.48, 231188.6, 37377.46)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -3469.41,
    y1: 506.26,
    x2: -3458.61,
    y2: 509.32,
    gradientTransform: "matrix(41.11, 0, 0, -55.65, 142870.35, 28713.73)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b8c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67e785"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -3458.45,
    y1: 509.41,
    x2: -3446.43,
    y2: 509.41,
    gradientTransform: "matrix(37.32, 0, 0, -51.5, 129378.22, 26638.79)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#50e1c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b6e885"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -3442.69,
    y1: 507.29,
    x2: -3435.9,
    y2: 508.94,
    gradientTransform: "matrix(32.21, 0, 0, -50.91, 111180.22, 26357.97)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -994.82,
    y1: 839.85,
    x2: -982.78,
    y2: 839.85,
    gradientTransform: "matrix(1.56, 0, 0, -2.34, 2032.13, 2169.68)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b8c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6da887"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -2972.9,
    y1: 760.88,
    x2: -2960.88,
    y2: 760.88,
    gradientTransform: "matrix(6.83, 0, 0, -2.87, 20809.98, 2434.64)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -2397.61,
    y1: 778.94,
    x2: -2385.59,
    y2: 778.94,
    gradientTransform: "matrix(3.5, 0, 0, -2.27, 8944.33, 2149.18)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -3128.24,
    y1: 557.28,
    x2: -3116.21,
    y2: 557.28,
    gradientTransform: "matrix(9.18, 0, 0, -12.22, 29165.32, 7099.33)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -3101.11,
    y1: 590.43,
    x2: -3089.09,
    y2: 590.43,
    gradientTransform: "matrix(8.68, 0, 0, -7, 27399.09, 4510.97)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -3217.06,
    y1: 543,
    x2: -3218.86,
    y2: 532.22,
    gradientTransform: "matrix(11.83, 0, 0, -18.23, 38609.53, 10079.52)",
    xlinkHref: "#linear-gradient-5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    className: "cls-1",
    d: "M950.2,390.14C879.94,151.41,633.26-22.27,399.38,2.32A349.35,349.35,0,0,0,171.82,114.13l1.55-1.73L89.24,204.82C7.47,294.52-23.25,428.46,18.83,571.53,89.07,810.27,335.72,984,569.62,959.34a349.67,349.67,0,0,0,226-110.13l84.14-92.4c-1,1.07-2,2.14-3,3.21C960.74,670.37,992.78,534.9,950.2,390.14ZM89.61,287.48q-.75,4.42-1.38,8.88C88.65,293.38,89.11,290.43,89.61,287.48Zm81.12-172.07q-2.73,3.09-5.34,6.25C167.15,119.52,169,117.47,170.73,115.41Zm-6.29,7.29c-1.73,2-3.43,4.12-5.11,6.23q2.49-3.21,5.09-6.24Zm-5.55,6.78c-1.75,2.14-3.46,4.42-5.18,6.66C155.44,133.9,157.16,131.68,158.89,129.48Zm-6.14,8c-1.65,2.2-3.21,4.43-4.81,6.69,1.55-2.26,3.14-4.49,4.8-6.7Zm-5.64,7.77c-1.54,2.2-3.07,4.42-4.56,6.67,1.48-2.25,3-4.47,4.55-6.67Zm-4.94,7.23q-2.31,3.51-4.55,7.09,2.22-3.54,4.53-7.05ZM136.73,161c-1.42,2.33-2.85,4.69-4.27,7.09,1.29-2.37,2.78-4.71,4.27-7.05Zm-4.92,8.35c-1.36,2.35-2.7,4.72-4,7.1,1.29-2.35,2.64-4.71,4-7.06Zm-4.28,7.72c-1.3,2.5-2.67,5-4,7.5,1.3-2.51,2.59-5,3.89-7.5Zm-4.72,9q-1.89,3.7-3.67,7.5c1.18-2.48,2.39-5,3.66-7.43Zm-4.28,8.79c-1.18,2.49-2.3,5-3.42,7.49,1.06-2.47,2.23-5,3.39-7.43Zm-3.66,8.05c-1.16,2.59-2.27,5.24-3.34,7.88,1.06-2.58,2.13-5.17,3.3-7.76Zm-4,9.46c-1.07,2.59-2.07,5.18-3.07,7.83q1.45-3.87,3-7.76Zm-3.69,9.22q-1.45,3.88-2.85,7.88c.92-2.59,1.87-5.25,2.85-7.76Zm-3,8.43c-1,2.73-1.84,5.48-2.72,8.24.85-2.73,1.76-5.53,2.67-8.23ZM101,239.88q-1.31,4.06-2.41,8.17c.75-2.74,1.54-5.44,2.38-8.12Zm-2.86,9.67c-.81,2.73-1.53,5.48-2.2,8.23.67-2.72,1.41-5.45,2.21-8.16Zm-2.35,8.73c-.71,2.83-1.39,5.7-2,8.55.66-2.79,1.29-5.69,2-8.55Zm-2.39,10.25c-.63,2.82-1.23,5.61-1.8,8.42.53-2.78,1.13-5.59,1.75-8.4Zm-2.1,10c-.55,2.84-1.06,5.69-1.56,8.57.45-2.86,1-5.71,1.54-8.57ZM88,298.14c-.4,2.9-.79,5.83-1.13,8.74.29-2.91.65-5.81,1.06-8.72Zm-1.3,10.36c-.33,3-.63,5.91-.9,8.88.22-2.94.53-5.89.85-8.8Zm-.93,9.25q-.41,4.54-.7,9.15c.14-3,.38-6.08.64-9.13ZM85,328.67q-.27,4.49-.45,9c.07-3,.2-6,.38-9Zm-.51,10.64c-.1,3-.18,6.08-.2,9.15,0-3,0-6.07.15-9.13Zm-.23,9.47v9.41c0-3.13-.08-6.26,0-9.4Zm16,120.38c.91,3.35,1.84,6.7,2.82,10.06-1.07-3.34-2-6.71-2.87-10.05ZM84.29,360c0,3.05.15,6.1.25,9.18-.14-3.05-.25-6.11-.29-9.16Zm.34,10.89c.14,3.15.3,6.28.52,9.44-.24-3.15-.43-6.28-.55-9.43Zm.53,9.63c.21,3.21.45,6.42.74,9.64-.3-3.16-.57-6.35-.79-9.55Zm.92,11.44c.28,3.11.61,6.24,1,9.37-.39-3.09-.71-6.18-1-9.3Zm1.19,11.13c.39,3.21.8,6.48,1.22,9.63-.47-3.11-.88-6.32-1.3-9.54Zm1.29,9.83q.7,4.86,1.52,9.81-.85-4.86-1.55-9.72Zm1.82,11.65c.54,3.21,1.07,6.47,1.72,9.53-.64-3.12-1.23-6.28-1.76-9.44Zm2.07,11.32c.64,3.29,1.29,6.59,2,9.88q-1.12-4.86-2.06-9.73Zm2,10q1.07,4.95,2.29,10c-.84-3.21-1.6-6.57-2.33-9.89Zm2.75,11.78c.8,3.21,1.61,6.47,2.47,9.63-.89-3.16-1.74-6.33-2.52-9.54ZM784.71,829.09c1.91-1,3.8-2,5.69-3l-5.72,3ZM653.76,867c3.36-.35,6.67-.76,10-1.19-3.3.43-6.61.8-10,1.16Zm13-1.6c2.31-.33,4.6-.65,6.88-1l-6.83,1Zm10.36-1.56c2.26-.37,4.51-.76,6.75-1.19q-3.36.63-6.73,1.18Zm9.8-1.72c3.06-.57,6.13-1.2,9.15-1.82-3,.62-6.07,1.29-9.14,1.81Zm9.54-1.93c3.21-.67,6.29-1.4,9.41-2.13l-9.39,2.13Zm12.27-2.87c2.15-.54,4.35-1.06,6.47-1.67C713.11,856.2,710.94,856.76,708.78,857.3Zm9.73-2.59c2.14-.58,4.25-1.19,6.3-1.83-2.07.63-4.16,1.22-6.29,1.79Zm9.2-2.71,8.29-2.58L727.73,852Zm9-2.84c3-1,5.9-2,8.8-3.08-2.9,1-5.83,2.07-8.81,3.06Zm11.46-4.07q3-1.07,6.11-2.33-3,1.17-6.11,2.31Zm9.06-3.53,5.86-2.41-5.84,2.4Zm8.57-3.61q3.75-1.62,7.49-3.34l-7.44,3.32Zm8.32-3.74c2.76-1.3,5.47-2.59,8.17-4-2.68,1.29-5.4,2.59-8.14,3.88Zm19-9.63q2.73-1.49,5.35-3c-1.78,1-3.56,2-5.35,3Zm23.12-13.8q-3.71,2.4-7.5,4.81c2.59-1.6,5.08-3.21,7.5-4.83Zm-8.49,5.36c-2.19,1.29-4.43,2.66-6.68,4,2.26-1.29,4.49-2.59,6.7-4Zm10.65-6.8c1.76-1.2,3.52-2.41,5.25-3.55l-5.17,3.51Zm7.77-5.36c1.64-1.16,3.28-2.34,4.9-3.53-1.6,1.16-3.21,2.34-4.89,3.49Zm7.21-5.25c2-1.49,4-3,5.91-4.52q-2.84,2.24-5.85,4.49Zm7-5.35q3.42-2.71,6.79-5.51-3.3,2.77-6.73,5.47Zm8.72-7.16,4.81-4.1c-1.55,1.35-3.13,2.71-4.75,4.06Zm7-6.15q2.24-2,4.41-4c-1.41,1.29-2.86,2.67-4.28,4Zm6.47-6q2.63-2.51,5.18-5c-1.66,1.68-3.35,3.35-5,5Zm6.27-6.09q3.09-3.06,6-6.22C873,763.91,871,765.93,869,768Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    className: "cls-2",
    d: "M879.78,756.87l-84.14,92.4a349.66,349.66,0,0,1-226,110.12C335.65,984,89,810.29,18.8,571.6c-42.09-143.08-11.32-277,70.41-366.73l84.14-92.41C91.58,202.19,60.85,336.11,102.91,479.2,173.15,717.93,419.79,891.57,653.71,867A349.79,349.79,0,0,0,879.77,756.87"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    className: "cls-3",
    cx: 526.28,
    cy: 434.49,
    rx: 394.74,
    ry: 477.82,
    transform: "translate(-149.31 531.09) rotate(-47.68)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    className: "cls-4",
    d: "M752.79,292.27C717.2,171.3,592.2,83.22,473.2,95.63a177.2,177.2,0,0,0-115,56.4c.18-.19.33-.4.49-.57h0l-45.54,50a165.07,165.07,0,0,0-11,13.37c-1.14,1.56-2.27,3.12-3.36,4.71q-3.25,4.82-6.2,9.78a173.56,173.56,0,0,0-14.57,31.89,197,197,0,0,0-8.82,85.37,16,16,0,0,0,.18,1.68A230.45,230.45,0,0,0,273.53,372c.31,1.29.61,2.76,1,4.1.91,3.77,1.89,7.5,3,11.32.25.9.56,1.8.84,2.7a262.29,262.29,0,0,0,26.14,58.35q3.81,6.35,8,12.49a282.54,282.54,0,0,0,22.64,29.17L609.73,763.64l45.54-50h0l102.07-313A212.14,212.14,0,0,0,752.79,292.27ZM314.7,251.78v-.18l-.24,2.15v-.68a7,7,0,0,0,.24-1.29Zm36.65-91.54-.45.59Zm-3.21,4.28L347.07,166ZM345,168.88l-1.13,1.66Zm-3,4.52L341,175.06Zm-3,4.8-.87,1.45c.27-.41.55-.86.84-1.29Zm-3.5,6.07-.28.55ZM333,189.08l-.79,1.6c.3-.48.52-1.06.79-1.55ZM330.55,194c-.28.62-.57,1.22-.84,1.85.32-.58.61-1.19.88-1.8Zm-2.24,5.1c-.26.61-.51,1.2-.77,1.84.28-.58.53-1.19.8-1.81Zm-2.13,5.35c-.21.51-.4,1.07-.62,1.55.23-.47.42-1,.64-1.5Zm-2.49,6.71-.15.51ZM322,216.38c-.18.58-.35,1.2-.51,1.76.21-.56.35-1.14.53-1.75Zm-1.56,5.34c-.18.67-.36,1.3-.53,2,.18-.65.37-1.3.59-2ZM319,227.21l-.49,2,.19-.81a11.92,11.92,0,0,1,.31-1.19Zm-1.67,7.07c.08-.46.19-.87.28-1.3-.11.56-.25,1.13-.36,1.7a1.19,1.19,0,0,0,.09-.36Zm-1.07,6a.84.84,0,0,1-.08.41,1.34,1.34,0,0,1,.1-.44Zm-.86,5.6c-.09.61-.17,1.2-.24,1.85.1-.63.18-1.29.25-1.87Zm5.89,85.2c-.18-.67-.34-1.3-.5-2,.19.64.33,1.29.51,2Zm-1.58-6.29c-.18-.77-.36-1.54-.52-2.31.18.81.35,1.52.55,2.29Zm-1.4-6.34c-.16-.77-.31-1.53-.48-2.3.2.75.33,1.51.5,2.32ZM317,312c-.13-.66-.25-1.29-.36-2,.14.65.26,1.3.37,2Zm-1.3-8-.78-6.23c-.08-.64-.13-1.29-.2-1.92a14.77,14.77,0,0,0,.21,1.89Zm-.59-6.11c0-.75-.12-1.5-.18-2.24,0,.73.11,1.49.18,2.22Zm-.45-6.15c0-.75-.08-1.49-.12-2.21,0,.7.09,1.44.13,2.15Zm-.26-20a12.2,12.2,0,0,1,.09-1.81,15,15,0,0,1-.08,1.77Zm.31-5.84c0-.72.11-1.42.17-2.13,0,.66-.11,1.37-.16,2.13Zm40.73-103.55,1.06-1.19ZM585.64,480.9c-86.72,9.06-178-55.23-204-143.68s23.13-167.56,109.83-176.63,178,55.19,204.05,143.68-23.11,167.4-109.79,176.55Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    className: "cls-5",
    d: "M313.26,201.49l45.51-50C317.35,197,301.71,265,323.06,337.45a271,271,0,0,0,57.53,102.78l-45.55,50A271.19,271.19,0,0,1,277.5,387.47C256.18,314.94,271.77,247,313.26,201.49Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    className: "cls-6",
    d: "M473.31,95.66c119-12.44,244,75.64,279.59,196.63a212.07,212.07,0,0,1,4.55,108.32L655.27,713.67,380.61,440.22a271.09,271.09,0,0,1-57.55-102.78C287.46,216.45,354.68,108.14,473.31,95.66ZM585,474.63c86.72-9.06,135.91-88.18,109.8-176.64S577.38,145.25,490.72,154.31,354.81,242.5,380.88,330.94,498.24,483.68,585,474.62"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    className: "cls-7",
    d: "M380.59,440.22a271.07,271.07,0,0,1-57.54-102.78C301.71,265,317.3,197,358.77,151.47l-45.56,50c-41.42,45.52-57,113.48-35.71,186A271.34,271.34,0,0,0,335,490.22L609.7,763.66l45.57-50Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    className: "cls-8",
    d: "M500.16,204.79l-4.11-14.43L481.34,204l4.09,14.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    className: "cls-9",
    d: "M518.36,251.76a31.52,31.52,0,0,1,6.74,12.68l1.08,3.71,41.56-5.82,14.72-13.68-41.55,5.85-1.08-3.72a31.21,31.21,0,0,0-6.74-12.68,12,12,0,0,0-11.15-4.29,12.52,12.52,0,0,0-6.9,2.91l-14.71,13.67a12.46,12.46,0,0,1,6.9-2.91A12.06,12.06,0,0,1,518.36,251.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    className: "cls-10",
    d: "M572.28,380.91l-14.72,13.7A63.19,63.19,0,0,0,585,381l14.73-13.7A63.17,63.17,0,0,1,572.28,380.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    className: "cls-11",
    d: "M505.58,323.25c6.71,1.56,12.95,3.21,18.86,4.81a55.44,55.44,0,0,1,15.25,6.82,21.51,21.51,0,0,1,8.92,12.71,17.22,17.22,0,0,1-.51,12,9.8,9.8,0,0,1-2.3,3.21l14.72-13.68a9.66,9.66,0,0,0,2.3-3.21,17.17,17.17,0,0,0,.5-12,21.54,21.54,0,0,0-8.91-12.74,56.45,56.45,0,0,0-15.29-6.78c-5.86-1.67-12.14-3.3-18.86-4.8a85.09,85.09,0,0,1-19.49-7.11A58.31,58.31,0,0,1,483.63,289a59.66,59.66,0,0,1-12-24,58.45,58.45,0,0,1-.94-34.51,35.14,35.14,0,0,1,9.51-14.63h0l-14.72,13.68Q447.76,246,456.9,278.68a59.3,59.3,0,0,0,12,23.95,58.13,58.13,0,0,0,17.12,13.53A85.43,85.43,0,0,0,505.58,323.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    className: "cls-12",
    d: "M550.3,384a67.3,67.3,0,0,1-38.13-8.5,53.73,53.73,0,0,1-21.29-32.91L489,335.85l-14.72,13.68,1.89,6.73a53.68,53.68,0,0,0,21.33,32.89,59.48,59.48,0,0,0,27,8.23c1.77.16,3.59.25,5.45.3s3.75,0,5.69,0l6.27,22.41,22-3.09,14.72-13.67-22,3.09Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    className: "cls-13",
    d: "M518.06,187.23l4.05,14.43a58.2,58.2,0,0,1,38.83,10.21,68.28,68.28,0,0,1,21.43,36.75l-41.55,5.82-1.08-3.71A31.66,31.66,0,0,0,533,238a12,12,0,0,0-11.13-4.27,10.36,10.36,0,0,0-9.16,6.29,17.5,17.5,0,0,0-.36,11.1,21.33,21.33,0,0,0,9.22,12.94,58.11,58.11,0,0,0,16,6.76c6.08,1.64,12.57,3.16,19.42,4.5A81,81,0,0,1,577,282.3a59.37,59.37,0,0,1,17.86,13.85,62.2,62.2,0,0,1,12.61,25.15,47.32,47.32,0,0,1-2.15,39.41A53.75,53.75,0,0,1,572.27,381l6.26,22.41-22,3.09L550.26,384a67.16,67.16,0,0,1-38.13-8.57,53.61,53.61,0,0,1-21.25-32.94L489,335.78l42.92-6,1.29,4.74a26.48,26.48,0,0,0,8.42,14.91,16.16,16.16,0,0,0,12,2.76,10.93,10.93,0,0,0,9.27-6.26,17.3,17.3,0,0,0,.5-12,21.44,21.44,0,0,0-8.93-12.71,55.37,55.37,0,0,0-15.27-6.81c-5.87-1.67-12.16-3.3-18.86-4.8a86,86,0,0,1-19.49-7.09A58.24,58.24,0,0,1,483.68,289a59.18,59.18,0,0,1-12-24q-13.08-46.6,28.58-60.22l-4.11-14.41Z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    className: "cls-14",
    d: "M1538.7,487.72V649.65h-75.83V511.58c0-36-7.48-48.19-34.17-48.19-23.87,0-38.84,14.51-38.84,47.73v138.5H1315V511.68c0-36.05-7.48-48.22-34.16-48.22-23.4,0-38.83,14.51-38.83,47.75V649.72h-74.91V410H1242V444.6h.94a85.51,85.51,0,0,1,74.88-42.12,64,64,0,0,1,62.72,42.12h1c20.59-23.86,41.65-42.12,80.5-42.12C1510.14,402.52,1538.7,432.93,1538.7,487.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    className: "cls-14",
    d: "M1700.11,657.13c-80,0-128.24-52.84-128.24-127.3s48.19-127.31,128.24-127.31c79.55,0,127.77,52.84,127.77,127.31S1779.71,657.13,1700.11,657.13Zm0-56.16c32.75,0,52.83-24.8,52.83-71.19s-20.12-71.09-52.83-71.09c-33.24,0-53.32,24.79-53.32,71.09S1666.93,601,1700.11,601Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    className: "cls-14",
    d: "M2095.17,487.72V649.65h-74.85V511.58c0-36-12.64-48.19-37.44-48.19-28.55,0-45,14.51-45,47.73v138.5h-74.87V410h75V444.6h.93a84.17,84.17,0,0,1,78.67-42.12C2063.76,402.52,2095.17,432.93,2095.17,487.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    className: "cls-14",
    d: "M2297.36,577.1h74.42c-13.11,48.2-50.48,80-115.6,80-79.57,0-127.78-52.41-127.78-127.3,0-73,47.28-127.3,123.56-127.3,81.91,0,123.57,59.9,123.57,147H2203.29a49.32,49.32,0,0,0,47,51.48c1.48.06,3,.06,4.43,0C2280.5,601,2292.68,588.8,2297.36,577.1Zm-94.09-73h97.36c0-33.24-20.14-50.1-48.68-50.1s-48.68,16.83-48.68,50.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    className: "cls-14",
    d: "M2415.32,727.79V671.62h.93c20.59,4.68,37.44,2.34,45.41-9.84,7-10.77,5.61-25.73-1.88-46.81l-78.16-205h74.9l54.28,157.27h.95L2557.14,410H2632l-81.45,244.34c-20.61,61.31-43.05,78.17-93.61,78.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    className: "cls-14",
    d: "M2814.07,345.87c-79.57,0-113.26,73.48-113.26,136.22,0,63.18,24.33,136.66,108.57,136.66a105,105,0,0,0,109-100.79h0c.07-1.66.09-3.32.08-5H2809.38V475.55h151.21V649.62h-28.1l-14.08-47.27h-.93c-25.27,35.12-56.64,53.82-108.12,53.82-97.37,0-150.72-73-150.72-174.12,0-100.63,62.72-173.63,155.39-173.63,84.68,0,129.16,44,140.91,107.68h-42.13C2903,368.35,2864.62,345.87,2814.07,345.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    className: "cls-14",
    d: "M3027.9,315h132.93c61.3,0,108.57,27.19,108.57,97.36s-47.22,97.39-108.52,97.39h-90.8V649.64H3027.9ZM3070,472.25h95.48c41.65,0,61.78-19.18,61.78-59.89s-20.11-59.89-61.78-59.89H3070Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    className: "cls-14",
    d: "M3564.3,562.08c0,48.7-36,94.09-120.74,94.09-79.1,0-140.41-42.12-145.09-118.87h42.12c4.7,45.87,32.75,81.44,103,81.44,58,0,78.67-26.66,78.67-56.63,0-45.86-24.79-54.29-99.67-71.63-50.07-11.74-110-29-110-94.09,0-52.84,40.72-88,114.67-88,71.2,0,120.77,36.5,126.38,105.76h-42.12c-6.09-44.95-31.37-68.34-84.24-68.34-47.28,0-72.56,18.26-72.56,45.87,0,44.48,36,50.49,85.19,62.73C3515.17,473.22,3564.3,485.82,3564.3,562.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M3710.22,413.12l-15.69-26.93h-10.4v26.93h-8.6V347.24h21.26a28.1,28.1,0,0,1,12.62,2.56,17.7,17.7,0,0,1,7.7,6.9,19.14,19.14,0,0,1,2.56,9.92,19.39,19.39,0,0,1-3.92,12q-3.93,5.2-11.77,6.9l16.54,27.6Zm-26.09-33.84h12.66q7,0,10.49-3.44a12.35,12.35,0,0,0,3.5-9.22q0-5.87-3.45-9.07t-10.54-3.22h-12.66Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 3695.62,
    cy: 379.1,
    r: 61.17
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyGpsHorizontalWhiteText);
export default __webpack_public_path__ + "static/media/moneyGPS-horizontal-white-text.75057ac86618a03d90792b04be071aa5.svg";
export { ForwardRef as ReactComponent };